import React, { useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import { Form, Button, Alert } from "react-bootstrap";

const AddFormula = () => {
  const [form, setForm] = useState({
    formulationName: "",
    content: "",
    preparation: "",
    usage: "",
    indication: "",
    reference: "",
  });

  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      await api.post("/formulas", form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMessage({ type: "success", text: "Formül başarıyla eklendi!" });

      setForm({
        formulationName: "",
        content: "",
        preparation: "",
        usage: "",
        indication: "",
        reference: "",
      });
    } catch (error) {
      setMessage({ type: "danger", text: "Hata oluştu." });
    }
  };

  return (
    <AdminLayout>
      <h2>➕ Yeni Formül Ekle</h2>

      {message && <Alert variant={message.type}>{message.text}</Alert>}

      <Form onSubmit={handleSubmit} className="mt-3">
        <Form.Group className="mb-3">
          <Form.Label>Formül Adı</Form.Label>
          <Form.Control
            name="formulationName"
            value={form.formulationName}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>İçerik</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="content"
            value={form.content}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Hazırlanışı</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="preparation"
            value={form.preparation}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Kullanımı</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="usage"
            value={form.usage}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Endikasyon</Form.Label>
          <Form.Control
            name="indication"
            value={form.indication}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Referans</Form.Label>
          <Form.Control
            name="reference"
            value={form.reference}
            onChange={handleChange}
          />
        </Form.Group>

        <Button type="submit" variant="primary">
          Kaydet
        </Button>
      </Form>
    </AdminLayout>
  );
};

export default AddFormula;
